"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalVariableServiceWorkerTemplate = GlobalVariableServiceWorkerTemplate;
function GlobalVariableServiceWorkerTemplate() {
    return 'const that = typeof global === \'object\' ? global : this;';
}
